import styled from 'styled-components';
import { SvgIcon } from '../../../Icon';
import { CSSProperties } from 'react';
import { theme } from '../../../../styles/theme';

export enum CellAlignment {
  Left = 'LEFT',
  Center = 'CENTER',
}

export const alignmentToJustifyContent: Record<
  CellAlignment,
  CSSProperties['justifyContent']
> = {
  [CellAlignment.Left]: 'start',
  [CellAlignment.Center]: 'center',
};

const CELL_PADDING = 8; // px
const BaseCell = styled.div<{ $alignment?: CellAlignment }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: ${({ $alignment }) =>
    alignmentToJustifyContent[$alignment ?? CellAlignment.Center]};

  padding: 0 ${CELL_PADDING}px;
`;

export const ColumnHeaderCell = styled(BaseCell)<{
  $isBackgroundFilled?: boolean;
  $isClickable?: boolean;
}>`
  background-color: ${theme.colors.level2};
  color: ${theme.colors.secondary800};
  font-size: 12px;
  font-weight: 600;

  ${({ $isClickable }) =>
    $isClickable &&
    `
      cursor: pointer;
      user-select: none;
  `};

  ${({ $isBackgroundFilled }) =>
    $isBackgroundFilled &&
    `
      background-color: ${theme.colors.tableHeader};
    `};
`;

const BodyCell = styled(BaseCell)<{ $isBackgroundFilled?: boolean }>`
  background-color: ${({ $isBackgroundFilled }) =>
    $isBackgroundFilled ? theme.colors.tableHeader : theme.colors.level2};
`;

export const Value = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0; // so text-overflow: ellipsis will work in flexbox
  margin-right: 8px; // offset for live indicator
`;

export const RowHeaderCell = styled(BodyCell)`
  font-size: 12px;
  font-weight: 600;
`;

export const ColorCodedValue = styled.div<{
  $backgroundColor?: string;
  $fontColor?: string;
}>`
  display: flex;
  align-items: center;
  justify-content: center;

  color: ${({ $fontColor }) => $fontColor ?? 'inherit'};
  background-color: ${({ $backgroundColor }) =>
    $backgroundColor ?? 'transparent'};

  &:hover {
    cursor: pointer;
  }
`;

export const DataValueCell = styled(BodyCell)`
  font-size: 12px;
  font-weight: 600;
  align-items: stretch; // allocate all the space vertically so we can center ColorCodedValue

  padding: 1px; // there is a thin 1px outline of the value cell per design

  ${ColorCodedValue} {
    flex: 1;
    padding: 0 ${CELL_PADDING - 1}px;
  }
`;

export const EventInfo = styled.div`
  max-width: 300px;
  font-size: 10px;
  font-weight: 500;
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const RetentionLiveIcon = styled(SvgIcon)`
  position: absolute;
  right: 8px;
  top: 12px;
`;

export const SubjectLabel = styled.div`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;
